<template>
    <div :id="target" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-width">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                    <h5 class="modal-title">Preview</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <iframe width="700" :height="modalHeight" :id="iframeId" style="border:none;" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api/layout'
    export default {
        name: "MailTypePreviewModal",
        components: {
        },
        props: {
            target: {
                type:String,
                required: true
            },
        },
        data() {
            return {
                modalData:{},
                regex:/%([1-9]{1,1})(\:)([S|N|T])(\:DDMMYYYY)?(\:HH24MMDDMMYYYY)?(\:HH24)?%/g,
                htmlContent: '',
                modalWidth: window.innerWidth - 500,
                modalHeight: window.innerHeight - 150
            }
        },
        computed: {
            iframeId: function() {
                return this.target+'_output_iframe'
            },
            // editedContent: function() {
            //     if(!this.modalData.tmplContent) return ''
            //     let keyList = this.modalData.tmplContent.match(this.regex)
            //     let content = this.modalData.tmplContent
            //     for(let i=0; i < keyList.length; i++) {
            //         content = this.$filters.replaceAll(content,keyList[i],'<span style="color:#0200FF;font-weight:bold">'+keyList[i]+'</span>')
            //     }
            //     return content
            // }
        },
        created() {
            window.addEventListener('resize', () => {
                this.resizeHandler()
            });
        },
        methods: {
            resizeHandler: function() {
                this.modalHeight = window.innerHeight - 300
                this.modalWidth = window.innerWidth -150
            },
            setData: function (data, name) {
                this.layoutName = name
                this.modalData = data
            },
            getMailLayoutHtml: function() {
                api.getS3Html(this.layoutName).then((result)=>{
                    this.showContent(result.data)
                }).catch((err)=>{
                    this.$notify.error('Load Fail',err)
                })
            },
            showContent(html) {
                let content = this.modalData.tmplContent
                // for(let row of this.modalData.params) {
                //     let changeKey = '%'+row.key+':'+row.type+(row.format?':'+row.format:'')+'%'
                //     content = this.$filters.replaceAll(content,changeKey,row.value?row.value:'')
                // }
                let html_content = html.replace('{{{content}}}',content)
                document.getElementById(this.iframeId).src = "data:text/html;charset=utf-8," + encodeURIComponent(html_content);
            }
        },
        watch: {
            'modalData': function(val) {
                this.getMailLayoutHtml()
            },
            'htmlContent':function(val) {
                document.getElementById(this.iframeId).src = "data:text/html;charset=utf-8," + encodeURIComponent(val);
            }
        }
    }
</script>

<style scoped>
    .modal-header .close {
        top:4% !important;
    }
    .modal-header {
        padding: 9px 19px !important;
    }
    /*.modal-width { max-width: 1200px}*/
    .modal-width {
        max-width: 731px;
    }
    .cus-col-7 {
        flex: 0 0 61.33333%;
        max-width: 61.33333%;
        position: relative;
        width: 100%;
        padding-right: .625rem;
        padding-left: .625rem;
    }
    .cus-col-5 {
        flex: 0 0 38.66667%;
        max-width: 38.66667%;
        position: relative;
        width: 100%;
        padding-right: .625rem;
        padding-left: .625rem;
    }
</style>
